import { Injectable } from '@angular/core';
import { Presenter } from 'src/app/core/presenter';
import { PermissionInput } from 'src/app/model.ts/rol.model';
import { SystemsRolesPermissionsService } from 'src/app/services/systems-roles-permissions.service';
import { UsersRolesPermissionsService } from 'src/app/services/users-roles-permissions.service';

import { GeneratePermissionView } from '../generate-permission.view';

@Injectable({
    providedIn: 'root',
})
export class GeneratePermissionPresenter implements Presenter {
    view: GeneratePermissionView;

    constructor(
        private usersRolesPermissionsService: UsersRolesPermissionsService,
        private systemsRolesPermissionsService: SystemsRolesPermissionsService
    ) {}

    savePermission(permission: PermissionInput) {
        this.view.blockUi();
        this.usersRolesPermissionsService.savePermission(permission).subscribe(
            () => {
                this.view.showSuccess('', 'Permiso guardado correctamente');
                this.view.closeView();
            },
            (error) => {
                this.view.showError('Error', error);
            }
        );
    }

    listSystems() {
        this.view.blockUi();
        this.systemsRolesPermissionsService
            .listSystemsByStatus(0, 10, '', true)
            .subscribe(
                ({ data }) => {
                    if (data) {
                        this.view.systems = data.systems.data;
                    } else {
                        this.view.showWarn(
                            'Atención',
                            'No existen sistemas cargados en la base de datos'
                        );
                    }
                },
                (error) => {
                    this.view.showError('Error', error);
                }
            );
    }
}
